import React, { useLayoutEffect, useRef, useState } from 'react';

const PortalTableScroller = ({ children }) => {
    const topScrollRef = useRef(null);
    const viewportRef = useRef(null);
    const bodyScrollRef = useRef(null);
    const [metrics, setMetrics] = useState({ scrollWidth: 0, clientWidth: 0 });

    const updateMetrics = () => {
        const body = bodyScrollRef.current;
        const viewport = viewportRef.current;

        if (!body || !viewport) {
            return;
        }

        const nextMetrics = {
            scrollWidth: body.scrollWidth,
            clientWidth: viewport.clientWidth
        };

        setMetrics((currentMetrics) => (
            currentMetrics.scrollWidth === nextMetrics.scrollWidth
            && currentMetrics.clientWidth === nextMetrics.clientWidth
                ? currentMetrics
                : nextMetrics
        ));
    };

    useLayoutEffect(() => {
        updateMetrics();

        const body = bodyScrollRef.current;
        const viewport = viewportRef.current;

        if (!body || !viewport) {
            return undefined;
        }

        let observer;

        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(() => updateMetrics());
            observer.observe(viewport);
            observer.observe(body);

            if (body.firstElementChild) {
                observer.observe(body.firstElementChild);
            }
        }

        window.addEventListener('resize', updateMetrics);

        return () => {
            if (observer) {
                observer.disconnect();
            }

            window.removeEventListener('resize', updateMetrics);
        };
    });

    const handleTopScroll = () => {
        const topScroll = topScrollRef.current;
        const bodyScroll = bodyScrollRef.current;

        if (!topScroll || !bodyScroll || bodyScroll.scrollLeft === topScroll.scrollLeft) {
            return;
        }

        bodyScroll.scrollLeft = topScroll.scrollLeft;
    };

    const handleBodyScroll = () => {
        const topScroll = topScrollRef.current;
        const bodyScroll = bodyScrollRef.current;

        if (!topScroll || !bodyScroll) {
            return;
        }

        if (topScroll.scrollLeft !== bodyScroll.scrollLeft) {
            topScroll.scrollLeft = bodyScroll.scrollLeft;
        }
    };

    const hasHorizontalOverflow = metrics.scrollWidth > metrics.clientWidth + 1;

    return (
        <div className="portal-table-wrap portal-table-scroll-shell">
            {hasHorizontalOverflow ? (
                <div
                    aria-label="Barra horizontal da tabela"
                    className="portal-table-scrollbar"
                    onScroll={handleTopScroll}
                    ref={topScrollRef}
                >
                    <div
                        className="portal-table-scrollbar-inner"
                        style={{ width: metrics.scrollWidth }}
                    />
                </div>
            ) : null}

            <div className="portal-table-viewport portal-table-scroll-viewport" ref={viewportRef}>
                <div
                    className="portal-table-scroll-body"
                    onScroll={handleBodyScroll}
                    ref={bodyScrollRef}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default PortalTableScroller;
